module.exports = __webpack_public_path__ + "img/3_159.8f5231e2.png";